export default {
  SET_OPERATIONTLIST(state, operationlist)
  {
    state.operationlist = operationlist
  },
  SET_PRODUCTLIST(state, productlist)
  {
    state.productlist = productlist
  },
  SET_TRANSPORTLIST(state, transportlist)
  {
    state.transportlist = transportlist
  },
  SET_UPLOADLISTEFACTURA(state, efacturastobesent)
  {
    state.efacturastobesent = efacturastobesent
  },
  SET_DOWNLOADINVOICE(state, downloadinvoices)
  {
    state.downloadinvoices = downloadinvoices
  },
  REMOVE_PENDING_INVOICE(state, id)
  {
    state.downloadinvoices = state.downloadinvoices.filter(inv => inv.id !== id)
  },
  SET_DOWNLOADINVOICESTREADTED(state, downloadinvoicestreated)
  {
    state.downloadinvoicestreated = downloadinvoicestreated
  },
  SET_INSITUTIONS(state, institutions)
  {
    state.institutions = institutions
  },
  SET_ACCOUNT_BANK(state, accountbank)
  {
    state.accountbank = accountbank
  },
  SET_BANK(state, bank)
  {
    state.bank = bank
  },
}
